
import {
    RELATED_CORPORATE_LINKS_CHANGE,
    MULTI_CORPORATE_CHANGE
 } from '../../actions/types';
 
 const initialState = {
    relatedCorporates: [],
    multiCorporates: []
 };
 
 
 const setRelatedCorporateLinks = (state, action) => {
     const relatedCorporates = action.payload.relatedCorporates || [];
     return {
         ...state,
         relatedCorporates,
         multiCorporates: []   
     }
 }

 const setMultiCorporates = (state, action) => {
     const multiCorporates = action.payload.relatedCorporates|| [];

     return {
         ...state,
         multiCorporates
     }
 }
 
 
 export default (state = initialState, action) => {
     switch (action.type) {
         case RELATED_CORPORATE_LINKS_CHANGE:
             return setRelatedCorporateLinks(state, action);
             break;

         case MULTI_CORPORATE_CHANGE:
             return setMultiCorporates(state, action);
 
         default:
             return state;
             break;
     }
 }